import React, { type JSX } from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

const InfoIcon = (): JSX.Element => <MaskIcon category="Semantics" name="icon-circle-solid-info" size={24} />;

export default InfoIcon;
